export default __webpack_public_path__ + "static/media/avatar_141.598e1bb3.png";